import React from "react";
import Flex from "@/components/layout/Flex";
import Visibility from "@/components/shared/Visibility";
import Button from "@/components/ui/Button";
import { getTags } from "@/content/helpers";
import { breakpointClasses, cls, cn, splitBreakpointProps } from "@/lib/utils";
import type { TagsProps } from "./types";

function Tags({
  clickable = true,
  tags = [],
  buttonProps,
  className,
  ...props
}: TagsProps) {
  const { bp, native } = splitBreakpointProps(props);
  const classes = breakpointClasses(bp);

  const sharedClassName = cls`text-[0.5rem] h-6 ~p-1/2 rounded-sm uppercase`;

  const tagsList = getTags([...tags]);

  return (
    <Visibility shouldShow={tags.length > 0}>
      <Flex.Row
        gap="gap-2"
        wrap="wrap"
        justify="start"
        className={cn(className, classes)}
        {...native}
      >
        {tagsList.map(tag => (
          <React.Fragment key={tag.label}>
            <Visibility shouldShow={clickable}>
              <Button.Link
                variant="secondary"
                className={cn(sharedClassName)}
                href={tag.href ?? ""}
                aria-label={`Go to ${tag.label} page`}
                {...buttonProps}
              >
                {tag.label}
              </Button.Link>
            </Visibility>

            <Visibility shouldShow={!clickable}>
              <Flex.Row
                justify="center"
                items="center"
                className={cn(
                  sharedClassName,
                  "bg-secondary text-secondary-foreground",
                )}
              >
                {tag.label}
              </Flex.Row>
            </Visibility>
          </React.Fragment>
        ))}
      </Flex.Row>
    </Visibility>
  );
}

Tags.displayName = "Tags";

export default Tags;
